/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversionsOverviewRequestBody
 */
export interface ConversionsOverviewRequestBody {
    /**
     * 
     * @type {Array<number>}
     * @memberof ConversionsOverviewRequestBody
     */
    localities: Array<number>;
    /**
     * List of dates to fetch statistics for
     * @type {Array<string>}
     * @memberof ConversionsOverviewRequestBody
     */
    dates: Array<string>;
}

export function ConversionsOverviewRequestBodyFromJSON(json: any): ConversionsOverviewRequestBody {
    return ConversionsOverviewRequestBodyFromJSONTyped(json, false);
}

export function ConversionsOverviewRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversionsOverviewRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'localities': json['localities'],
        'dates': json['dates'],
    };
}

export function ConversionsOverviewRequestBodyToJSON(value?: ConversionsOverviewRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'localities': value.localities,
        'dates': value.dates,
    };
}

